module.exports = __webpack_public_path__ + "static/media/Bus Stop.75b60e0f.png";